<template>
  <div id="form-page">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/delivery-order"
                >Delivery Order</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit()">
        <b-row>
          <b-col md="5">
            <label class="labels">Number</label>
            <div class="form-group w-50 d-flex">
              <input
                type="number"
                class="form-control"
                v-model="model.number"
                placeholder="No. Delivery Order"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label class="labels">Customer *</label>
            <div
              class="form-group d-flex"
              v-bind:class="errors.has('customer') ? 'has-error' : ''"
              style="height: 2.25rem"
            >
              <b-input
                list="customers"
                v-model="model.selectedCustomerName"
                placeholder="Select Customer"
                required
                style="height: 100%"
              />
              <b-btn
                class="py-0 ml-1"
                variant="outline-danger"
                style="height: 100%"
                @click.prevent="model.selectedCustomerName = ''"
              >
                <i class="fas fa-times" style="font-size: 0.9rem"></i>
              </b-btn>
              <datalist id="customers">
                <option
                  v-for="(customer, index) in list.nameCustomers"
                  :key="index"
                  :value="customer.text"
                />
              </datalist>
              <p v-if="errors.has('customer') !== null"></p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Note</label>
            <div class="form-group">
              <textarea
                type="text"
                class="form-control"
                style="height: 140px;"
                v-model="model.note"
                placeholder="Note Delivery Order"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <div class="border-bottom mt-3"></div>

        <b-row class="mt-3">
          <b-col md="12" class="mt-3">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="small-text border-bottom py-5">
                    <th width="400">Item*</th>
                    <th width="60">Quantity</th>
                    <th width="100" class="text-center">Unit</th>
                    <th width="300" class="text-left ml-1"><p class="mt-3">Note</p></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(selectedItem, index) in selectedItems" :key="selectedItem.uuid">
                    <td width="400">
                      <b-form-input
                        v-model="selectedItem.name"
                        :plaintext="selectedItem.isCustomItem"
                        required
                        class="selected small-text"
                        style="margin-top:15px!important; white-space: pre-line;"
                        placeholder="Enter Item"
                      />
                    </td>
                    <td width="60">
                      <b-form-input
                        v-model="selectedItem.orderQuantity"
                        :plaintext="selectedItem.isCustomItem"
                        type="number"
                        required
                        class="text-center selected small-text"
                        style="margin-top:15px!important;"
                        placeholder="Enter Quantity"
                      />
                    </td>
                    <td width="100">
                      <b-form-input
                        v-model="selectedItem.isUnit.name"
                        :plaintext="selectedItem.isCustomItem"
                        type="text"
                        style="margin-top:15px!important;"
                        class="text-center selected small-text"
                        placeholder="..."
                      />
                    </td>
                    <td width="300">
                      <textarea
                        v-model="selectedItem.isNote"
                        :plaintext="selectedItem.isCustomItem"
                        class="m-3 selected small-text form-control"
                        type="text"
                        placeholder="Note ..."
                      ></textarea>
                    </td>
                    <td class="text-center">
                      <b-button
                        pill
                        v-b-tooltip.hover.right
                        title="Delete Row"
                        style="margin-bottom:5px!important;margin-left: 22px;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                        size="sm"
                        variant="danger"
                        @click="deleteSelectedItem(index)"
                      >
                        x
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-dropdown text="Add Item" variant="dark">
              <div
                style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
              >
                <v-select
                  multiple
                  v-model="selectedItems"
                  style="width: 100%;"
                  id="mySelect"
                  label="name"
                  @input="addToSelected(availableItem.uuid)"
                  :options="availableItems"
                  :reduce="(uuid) => uuid"
                  class="style-chooser mt-1"
                  placeholder="Type to search Items"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!selectedItems"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col md="4">
            <div class="mt-3">
              <b-button class="mr-2 btn-md" @click="goBack()" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
            </div>
          </b-col>
          <b-col md="4"></b-col>
          <b-col md="4">
            <div v-if="loadingButton" class="float-right mt-4">
              <b-button variant="warning" disabled>
                <b-spinner small type="grow"></b-spinner>
                Loading...
              </b-button>
            </div>
            <div v-else>
              <b-button
                :disabled="!disable"
                variant="warning"
                class="btn-back float-right mt-3"
                type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Create</b-button
              >
            </div>
          </b-col>
        </b-row>
      </form>
    </b-card>
    <b-modal id="bv-modal-error" hide-footer>
            <template v-slot:modal-title>
            </template>
            <div class="d-block">
                Uppss !! Masukkan Item terlebih dahulu
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-error')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
            <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
        </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
export default {
  name: 'form-page',
  components: {},
  data() {
    return {
      loadingButton: false,
      index: 1,
      apiUrl: {
        receipt: window.AppConfig.apiUrl + 'receipt',
      },
      model: {
        number: '',
        selectedCustomerName: '',
        customer: null,
        receiptItem: [],
        quantity: '',
        note: 'Barang sudah diterima dengan baik dan tidak dapat dikembalikan'
      },
      list: {
        nameCustomers: [],
      },
      modelValidations: {
        customer: {
          required: true,
        },
      },
      // isCustomItem: false,
      // isNote: false,
      isDeleted: false,
      selectedItems: '',
      selectedItem: {},
      availableItems: [],
      dataCustomer: [],
      dataItem: '',
      customerSales: '',
      currency: '',
    };
  },

  computed: {
    isComplete() {
      return this.selectedItem;
    },

    disable() {
      if (this.selectedItems.length !== 0) {
        return true;
      }
      return false;
    },
  },

  methods: {
    /****************************************************************************
     *                                FUNCTION IN HERE                          *
     ****************************************************************************/

    /**
     * @function doSubmit
     * send data to server
     */

    doSubmit() {
      this.loadingButton = true;
      const toSubmit = this.selectedItems.map((selectedItem) => ({
        uuid: '',
        itemList: selectedItem.isCustomItem ? '' : selectedItem.uuid,
        quantity: selectedItem.orderQuantity,
        // unit: selectedItem.isUnit.uuid,
        note: selectedItem.isNote,
      }));
      let selected = this.model.selectedCustomerName;
      this.model.customer =
        this.list.nameCustomers.find((customer) => {
          return customer.text === selected;
        })?.value ?? null;
      if (this.model.customer === null || this.model.customer === '') {
        this.$store.dispatch('notification/error', new Error('Please choose a valid Customer'));
        return;
      }
      if (this.selectedItem.uuid === null) {
        this.$bvModal.show('bv-modal-error')
        this.$store.dispatch('notification/error', new Error ('Masukkan item'));
        return;
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('number', this.model.number);
          formData.append('customer', this.model.customer);
          formData.append('note', this.model.note);
          formData.append('items', JSON.stringify(toSubmit));
          console.log('send', toSubmit);
          this.$http
            .post(this.apiUrl.receipt, formData)
            .then((response) => {
              this.$store.dispatch('notification/success', 'Delivery Order has been Created');
              window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
            })
            .catch((error) => {
              this.loadingButton = false;
              this.$store.dispatch('notification/error', error);
            });
        } else {
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          this.loadingButton = false;
        }
      });
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     *
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        uuid: availableItem.uuid,
        name: availableItem.name,
        isUnit: availableItem.itemUnit,
        orderQuantity: 0,
        isNote: '',
        isCustomItem: false,
        isDeleted: false,
      }));
      console.log('ini item wak', this.availableItems);
    },

    /**
     * @function addToSelected
     * @param {{ isManuallyEntered, name, orderQuantity, uuid }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push(item);
      console.log(this.selectedItems);
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        taxValue: null,
        orderQuantity: 0,
        isUnit: null,
        isNote: '',
        isCustomItem: true,
        isDeleted: false,
      });
      console.log(this.selectedItems);
    },

    /**
     * @function deleteSelectedItem
     * @param { Number } index
     * delete an item from the selectedItems array,
     * and from the quotation form.
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */
    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(({ uuid }) => uuid);
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.uuid),
      );
    },

    /**
     * fetch customer data from API to enter into vue select customer
     */
    getCustomer() {
      this.$http
        .get(window.AppConfig.apiUrl + 'customer')
        .then((response) => {
          this.list.nameCustomers = [];
          response.data?._embedded?.customer?.forEach((customer) => {
            this.list.nameCustomers.push({
              value: customer.uuid,
              text: customer.name,
            });
          });
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
        });
    },

    //back to prev pages
    goBack() {
      window.goBack(this);
    },
  },

  mounted() {
    this.fetchAvailableItems();
    this.getCustomer();
    // this.getRemainingAvailableItems();

    /**
     * Use mounted to auto trigger function on this file
     */
  },
};
</script>
